import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarDays: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarDays"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H3ZM9 11H7V13H9V11ZM9 15H7V17H9V15ZM11 15H13V17H11V15ZM13 11H11V13H13V11ZM15 11H17V13H15V11ZM19 5H5V7H19V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarDays;
